"use client"

import { useIdentity } from "@/lib/providers/identity"

/**
 * A stable identity segment (`<userId>:<orgId>`) appended to every chat query key.
 *
 * The global `IdentityProvider` clears the whole query cache on a `userId` change
 * (logout / user switch) but NOT on an `orgId` change for the same user. Scoping
 * the chat keys by both fields means a user who switches org can never see the
 * previous org's cached conversations / unread counts / message pages before the
 * refetch lands — a defence-in-depth guard for a multi-tenant surface.
 *
 * Kept as the LAST key element so the otel span name (element 0) is unchanged and
 * prefix-based `invalidateQueries` calls still match.
 */
export function useChatScope(): string {
  const { identity } = useIdentity()
  return `${identity?.userId ?? "anon"}:${identity?.orgId ?? "none"}`
}
